import { createAsyncThunk } from "@reduxjs/toolkit";
import { SortDirection } from "@shared/models/general";
import { callDocumentsAPI } from "@documents/store/thunks/callDocumentsAPI";
import { ThunkApiConfig } from "@shared/models/redux";
import { openNotificationThunk } from "@store/Notification/thunks";
// import { setHighlightedVideo } from "@dataRooms/store/ducks";
// import { DocumentRow } from "@documents/models/dataGrid.models";
import { DocumentResponse } from "@documents/models/api.models";
// import { normalizeDocumentResponse } from "@documents/utils";
// import { FetchDocumentResponse } from "@documents/models/api.models";

export const fetchDataRoomSetupDocumentsThunk = createAsyncThunk<
  DocumentResponse[],
  {
    documentTypeIds: number[];
    entitledEntityIds: number[];
    sortDirection: SortDirection;
    sortKey: string;
  },
  ThunkApiConfig
>(
  "dataRoomSetup/fetchEntityDocuments",
  async ({ documentTypeIds, entitledEntityIds, sortDirection, sortKey }, { rejectWithValue, dispatch }) => {
    try {
      const documents = await dispatch(
        callDocumentsAPI({
          documentLocation: "Opportunity",
          documentStatuses: ["P", "A", "W", "V"],
          documentTypes: documentTypeIds,
          entitledEntityIds: entitledEntityIds,
          includeVideos: true,
          sortDirection,
          sortKey,
          userId: null,
          readOnlyFlag: null,
        })
      );
      //   const highlightedVideo = documents.results.find((document) => document.videoIsHighlighted);

      //   if (highlightedVideo) {
      //     dispatch(
      //       setHighlightedVideo({
      //         videoToken: highlightedVideo.videoToken,
      //         videoDescription: highlightedVideo.videoDescription,
      //         videoId: highlightedVideo.videoId,
      //         videoTokenExpiration: highlightedVideo.videoTokenExpiration,
      //         title: highlightedVideo.title,
      //       })
      //     );
      //   }

      return documents.results;
    } catch (e) {
      dispatch(
        openNotificationThunk({
          variant: "warning",
          text: "Failed to load data",
        })
      );

      return rejectWithValue("Failed to load entity documents");
    }
  }
);
